import { combineReducers } from 'redux';
import postOffice from './postOffice';
import notification from './notfication';
const adminReducer = combineReducers({
  postOffice,
  notification
});

export default adminReducer;
